"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var json_1 = require("../../../common/helpers/json");
var InstructorCompleteDriveController = /** @class */ (function () {
    function InstructorCompleteDriveController($rootScope, $scope, $state, UserService, UsersModel, VehiclesModel, DrivesModel, SchoolsModel, FlashService, driveSession, $q, VueStoreFactory) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.VehiclesModel = VehiclesModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.driveSession = driveSession;
        this.VueStoreFactory = VueStoreFactory;
        this.driveDate = new Date(this.driveSession.drive_date + " " + this.driveSession.start_time);
        this.policies = {};
        this.currentUser = UserService.getCurrentUser();
        this.loading = true;
        var getSchool = SchoolsModel.getSchoolByID(this.currentUser.school_id);
        var getDriveMeta = DrivesModel.getDriveMeta(this.driveSession.id);
        this.formatPoliciesResponse(this.VueStoreFactory.state.auth.policies);
        $q.all([getSchool, getDriveMeta]).then(function (responses) {
            _this.formatSchoolResponse(responses[0]);
            _this.driveSession = _this.formatDriveSession(responses[1]);
            _this.loading = false;
        });
    }
    InstructorCompleteDriveController.prototype.driveDuration = function () {
        return (0, time_1.formatDuration)(this.driveSession.session_length);
    };
    InstructorCompleteDriveController.prototype.formatDriveSession = function (response) {
        var hasGuardian = response.drive.student.usermeta.filter(function (meta) {
            return meta.meta_key === "guardian";
        }).length > 0;
        var parentMeta;
        if (hasGuardian) {
            parentMeta = response.drive.student.usermeta.find(function (meta) { return meta.meta_key === "guardian"; }).meta_value;
            response.drive.student.guardian = JSON.parse(parentMeta);
        }
        response.drive.student.phone = response.drive.student.usermeta.filter(function (meta) {
            return meta.meta_key === "phone";
        })[0].meta_value;
        var dob_meta = response.drive.student.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
        if (dob_meta) {
            response.drive.student.dob = dob_meta.meta_value;
        }
        else {
            response.drive.student.dob = "";
        }
        var drive = Object.assign(this.driveSession, response.drive);
        return drive;
    };
    InstructorCompleteDriveController.prototype.formatPoliciesResponse = function (response) {
        var _this = this;
        response.policies.forEach(function (policy) {
            var policyName = policy.name;
            _this.policies[policyName] = { id: policy.id };
            var policyMeta = {};
            policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            _this.policies[policyName].policymeta = policyMeta;
        });
    };
    InstructorCompleteDriveController.prototype.formatSchoolResponse = function (response) {
        // Safely filter locations - only include those with zoneparts when zoneparts exist
        response.locations = response.locations.filter(function (location) {
            return location.zoneparts && location.zoneparts.length > 0;
        });
        this.school = response;
    };
    InstructorCompleteDriveController.prototype.submit = function () {
        var _this = this;
        this.submitted = true;
        this.DrivesModel.complete(this.driveSession)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            _this.$state.go("drivecoach.instructor.dashboard", {}, { reload: true });
        })
            .catch(function (Error) {
            _this.submitted = false;
        });
    };
    return InstructorCompleteDriveController;
}());
InstructorCompleteDriveController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "UserService",
    "UsersModel",
    "VehiclesModel",
    "DrivesModel",
    "SchoolsModel",
    "FlashService",
    "driveSession",
    "$q",
    "VueStoreFactory",
];
exports.default = InstructorCompleteDriveController;
